export let UseCase;

(function (UseCase) {
  UseCase["CreateContent"] = "create-content";
  UseCase["TrackContacts"] = "track-contacts";
  UseCase["CloseDeals"] = "close-deals";
  UseCase["ConvertCustomers"] = "convert-customers";
  UseCase["Other"] = "other";
})(UseCase || (UseCase = {}));